import { defineStore } from "pinia";
import { ref, computed } from "vue";
export const useErrorsStore = defineStore("errors", () => {
  const error = ref(null);
  const hasError = computed(() => error.value !== null);
  function addError(err) {
    error.value = err;
  }
  return {
    hasError,
    addError,
  };
});
